/// <amd-module name="Feed/Connect/Protocols/Ivy" />
import { replaceRouteValues } from "VSS/Platform/Util/Url";

import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

import { PackagingProcotol } from "../Protocol";
import { PackagingTool, ToolId } from "../Tool";

class IvyProtocol extends PackagingProcotol {
    constructor() {
        super("Ivy", "Packaging.Feed.WebAccess.IvyUI");
    }

    public readonly area = "ivy";

    public getFeedUrl(packagingService: PackagingService, feed: IUxFeedView) {
        // TODO: Move route resolution to endpoints within this object
        const path = replaceRouteValues("_packaging/{feed}/{area}/{resource}/{*path}", {
            feed: feed.name,
            area: this.area,
            resource: "v1"
        });

        return packagingService.getUrl(feed.project, path);
    }
}

const IvyP = new IvyProtocol();

class IvyTool extends PackagingTool {
    constructor(id: ToolId, name: string, imageName: string) {
        super(id, name, IvyP, { src: `ms.feed/feed-connect/Content/${imageName}` }, false);
    }

    public readonly getToolLink = undefined;
}

export const Ivy = new IvyTool(ToolId.Ivy, "Ivy", "universal-package.svg");
